import React, { useContext, useEffect } from 'react';
import { Context } from '../../../context/global-data-provider';
import { GCategoryDataContext, SetGCategoryContext } from '../../../context/g-category-posts-list-provider';
import { useParams } from 'react-router-dom';
import E404 from '../error/e404';
import GalleryCategoryHeader from '../../containers/header/gallery-category-header';
import GCategoryPostsList from '../../containers/posts-list/g-category-posts-list';
import MainLoading from '../../components/loading/main-loading';

function GalleryCategory() {
  const { setCurrentRoute, deletedPostManager } = useContext(Context);
  const [category, categoryLoaded] = useContext(GCategoryDataContext);
  const [setCategory] = useContext(SetGCategoryContext);
  const { categoryId, uniqTitle } = useParams();

  useEffect(() => {
    setCurrentRoute('/category');

    setCategory(categoryId, uniqTitle);

    deletedPostManager.setPart('gCategory');
  }, [categoryId]);

  if (categoryLoaded === 'ok') {
    return (
      <React.Fragment>
        <GalleryCategoryHeader category={category} />
        <GCategoryPostsList category={categoryId} />
      </React.Fragment>
    );
  } else {
    if (categoryLoaded === 'loading') {
      return <MainLoading />;
    } else {
      return <E404 />;
    }
  }
}

export default GalleryCategory;
